module.exports = __webpack_public_path__ + "img/45432C_808361_B8C8BC_A5A27A-256px.9ffcaa62.png";